export function trimFormValues<T>(value: T): T {
    if (Array.isArray(value)) {
        return value.map((v) => trimFormValues(v)) as T;
    }

    if (value !== null && typeof value === "object") {
        return Object.keys(value).reduce((acc, key) => {
            const v = (value as any)[key];
            acc[key] = trimFormValues(v);
            return acc;
        }, {} as any);
    }

    if (typeof value === "string") {
        return value.trim() as any;
    }

    return value;
}
